import { render, staticRenderFns } from "./indicadoresG.vue?vue&type=template&id=4e582f2e"
import script from "./indicadoresG.vue?vue&type=script&lang=js"
export * from "./indicadoresG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports